let zIndex=40;//高于nav-bar
const PopupManager={
	zIndex,
	nextZIndex:()=>{
		return ++PopupManager.zIndex
	}
}
export default PopupManager;